<template>
  <div id="app">
    <Navbar/>
    <HeaderBackground/>
    <ParticlesJS />
    <AboutUs/>
    <Game/>
    <Contact/>
    <!--<SocialActivity/>-->
    <Footer/>
  </div>
</template>

<script>
import Navbar from './components/Navbar.vue'
import HeaderBackground from './components/HeaderBackground.vue'
import AboutUs from './components/AboutUs.vue'
import Game from './components/Game.vue'
import ParticlesJS from './components/particleJS.vue'
import Footer from './components/Footer.vue'
import Contact from './components/Contact.vue'
//import SocialActivity from './components/SocialActivity.vue'

export default {
  name: 'App',
  components: {
    Navbar,
    HeaderBackground,
    AboutUs,
    Game,
    ParticlesJS,
    Footer,
    Contact,
    //SocialActivity
  }
}
</script>

<style lang="scss">
#app {
  font-family: "Montserrat", "Open Sans", "Helvetica Neue", Arial, sans-serif;
  -webkit-font-smoothing: antialiased;
  -moz-osx-font-smoothing: grayscale;
}
body {
  height: 100vh;
  width: 100%;
}
.section{
  padding-top: 48px;
  background: black;
  color: white;
  h1{
    text-transform: uppercase;
    font-size: 2.25rem;
    padding-bottom: 5px;
    .firstTitle{
      margin-right: 15px;
    }
    .secondTitle{
      color: #62bedb;
      text-shadow: #0089ff 1px 0 10px;
    }
  }
}
</style>
